export default __webpack_public_path__ + "assets/images/1d183815388ebdd83982beea6dc59dd8.jpg";